/** plan (Phase 17.10 plan features): English + Arabic (Arabic is a draft for native review). */
const en = {
  "advanced": "Advanced",
  "lockedHint": "Part of the Advanced plan",
  "partOfAdvanced": "part of the Advanced plan.",
  "upgrade": "Upgrade",
  "askOwner": "Ask your organization's owner to upgrade.",
  "dialogTitle": "Upgrade to Advanced",
  "lockedTitle": "{feature} is part of Advanced",
  "alsoIncluded": "Advanced includes",
  "notNow": "Not now",
  "seePlans": "See plans",
  "viewOnly": "You can still see what's already here; changes need Advanced.",
  "f_liveControl": "Live View & remote control",
  "f_interactivity": "Interactivity",
  "f_dataFeeds": "Data feeds",
  "f_customApps": "Custom HTML5 apps",
  "f_logicRestrictions": "Logic restrictions",
  "f_regions": "Regions",
  "f_syncPlayback": "Synchronized playback",
  "f_monitoringWall": "Monitoring wall",
  "f_alerts": "Alerts",
  "f_scheduledReports": "Scheduled reports",
  "f_auditLog": "Audit log",
  "d_liveControl": "Watch any screen live and tap or swipe on it to control it remotely.",
  "d_interactivity": "Touch hotspots and remote keys that play content or open a web page.",
  "d_dataFeeds": "Live data (sheets, APIs) in your apps, with approval before changes go on screen.",
  "d_customApps": "Upload your own HTML5 apps with versions and settings.",
  "d_logicRestrictions": "All / Any rule groups on days, times, tags, groups, players, orientation and regions.",
  "d_regions": "Map areas that decide which content plays where.",
  "d_syncPlayback": "Screens in a group play the same content in step, frame for frame.",
  "d_monitoringWall": "Every screen's latest picture on one wall, with scheduled screenshots.",
  "d_alerts": "Get told when players go offline, fall out of sync, or run low on storage, memory or battery.",
  "d_scheduledReports": "Reports that run every day, week or month and arrive by email.",
  "d_auditLog": "Who did what and from where: sign-ins, changes and IP addresses.",
  "standardIncludes": "Content, campaigns, playlists and apps · publishing with restrictions · monitoring, health check, remote restart and screenshots · proof of play and reports · users and roles",
};

const ar: typeof en = {
  "advanced": "متقدمة",
  "lockedHint": "جزء من الخطة المتقدمة",
  "partOfAdvanced": "جزء من الخطة المتقدمة.",
  "upgrade": "ترقية",
  "askOwner": "اطلب من مالك المؤسسة الترقية.",
  "dialogTitle": "الترقية إلى المتقدمة",
  "lockedTitle": "{feature} جزء من الخطة المتقدمة",
  "alsoIncluded": "تشمل الخطة المتقدمة",
  "notNow": "ليس الآن",
  "seePlans": "عرض الخطط",
  "viewOnly": "لا يزال بإمكانك رؤية الموجود هنا؛ التغييرات تتطلب الخطة المتقدمة.",
  "f_liveControl": "العرض المباشر والتحكم عن بُعد",
  "f_interactivity": "التفاعل",
  "f_dataFeeds": "مصادر البيانات",
  "f_customApps": "تطبيقات HTML5 المخصصة",
  "f_logicRestrictions": "القيود المنطقية",
  "f_regions": "المناطق",
  "f_syncPlayback": "التشغيل المتزامن",
  "f_monitoringWall": "جدار المراقبة",
  "f_alerts": "التنبيهات",
  "f_scheduledReports": "التقارير المجدولة",
  "f_auditLog": "سجل التدقيق",
  "d_liveControl": "شاهد أي شاشة مباشرة والمسها أو اسحب عليها للتحكم بها عن بُعد.",
  "d_interactivity": "نقاط لمس ومفاتيح تحكم تعرض محتوى أو تفتح صفحة ويب.",
  "d_dataFeeds": "بيانات مباشرة (جداول، واجهات برمجية) في تطبيقاتك، مع موافقة قبل ظهور التغييرات.",
  "d_customApps": "ارفع تطبيقات HTML5 الخاصة بك مع إصدارات وإعدادات.",
  "d_logicRestrictions": "مجموعات قواعد (الكل / أي) على الأيام والأوقات والوسوم والمجموعات والمشغلات والاتجاه والمناطق.",
  "d_regions": "مناطق على الخريطة تحدد أي محتوى يُعرض وأين.",
  "d_syncPlayback": "تعرض شاشات المجموعة المحتوى نفسه بتزامن تام.",
  "d_monitoringWall": "أحدث صورة لكل شاشة على جدار واحد، مع لقطات مجدولة.",
  "d_alerts": "تنبيهك عند انقطاع المشغلات أو فقدان التزامن أو نقص التخزين أو الذاكرة أو البطارية.",
  "d_scheduledReports": "تقارير تُشغَّل يوميًا أو أسبوعيًا أو شهريًا وتصل بالبريد.",
  "d_auditLog": "من فعل ماذا ومن أين: عمليات الدخول والتغييرات وعناوين IP.",
  "standardIncludes": "المحتوى والحملات وقوائم التشغيل والتطبيقات · النشر مع القيود · المراقبة وفحص الحالة وإعادة التشغيل واللقطات عن بُعد · إثبات العرض والتقارير · المستخدمون والأدوار",
};

export default { en, ar };
